function Badge({ items, className = 'flex gap-1', ignoreList = [] }) {
  const listItem = items.filter(item => !ignoreList.some(prefix => item.tag.startsWith(prefix)))
  return (
    listItem.length > 0 && (
      <div className={className}>
        {listItem.splice(0, 2).map((item) => (
          <span
            className={`badge whitespace-nowrap border-white border-2 text-center ${item.customClass}`}
            style={`background-color:${item.backgroundColor}; color:${item.textColor}`}
          >
            {item.text}
          </span>
        ))}
      </div>
    )
  )
}

export default Badge
